import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store";
import { updateDashboardFields } from "../../../features/common/commonSlice";
import Eye from '../../../assets/images/icons/icons_view.png';

interface MeetingData {
    [key: string]: any;
}

const MultilingualDashboard2: React.FC<{ finYear: string; meetingType: any }> = ({
    finYear,
    meetingType,
}) => {
    const multilingual = useSelector(
        (state: RootState) => state.common.dashboardData["Multilingual Coverage"]
    );
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();

    const [languageTable, setLanguageTable] = useState<MeetingData[]>([]);

    const handleBack = () => {
        dispatch(
            updateDashboardFields({
                menu: "Multilingual Coverage",
                fields: {
                    meeting_language: "",
                    meeting_language_desc: "",
                    taskId: "",
                },
            })
        );
    };

    const handleViewClick = (task_id: any) => {
        dispatch(
            updateDashboardFields({
                menu: "Multilingual Coverage",
                fields: {
                    taskId: task_id,
                },
            })
        );
    };

    useEffect(() => {
        const fetchLanguageReport = async () => {
            try {
                const response = await axios.get(`${baseUrl}api/language_report/`,
                    {
                        params: {
                            meeting_language: multilingual.meeting_language,
                            fin_year: finYear,
                            meeting_type: meetingType.value || 0,
                        },
                    }
                );
                const data = response?.data?.data || [];
                setLanguageTable(data);
            } catch (error) {
                console.error("Error fetching language report:", error);
            }
        };

        fetchLanguageReport();
    }, [finYear, meetingType]);

    return (
        <div className="">
            <h5 className="recentGramSabha-sub-heading">Recent Gram Sabha Meetings</h5>
            <div className="mt-3">
            <div className="d-flex justify-content-between mb-2">
                <div className="d-flex mb-3">
                    <button className="back-btn me-2" onClick={handleBack}>
                        &larr; Back
                    </button>
                    <div className="data-chip me-2">{multilingual?.meeting_language_desc}</div>
                </div>
            </div>

            <div>
                <table className="table table-striped mt-3">
                    <thead className="thead-cus">
                        <tr>
                            <th className="left-radius">S.No.</th>
                            <th className="no-radius text-center">State Name</th>
                            <th className="no-radius text-center">ZP Name</th>
                            <th className="no-radius text-center">BP Name</th>
                            <th className="no-radius text-center">GP Name</th>
                            <th className="no-radius text-center">Meeting Date</th>
                            <th className="right-radius">View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {languageTable.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            languageTable.map((item, index) => (
                                <tr key={item.task_id || index}>
                                    <td>{index + 1}</td>
                                    <td className="text-center">{item.state_name || "-"}</td>
                                    <td className="text-center">{item.zp_name || "-"}</td>
                                    <td className="text-center">{item.bp_name || "-"}</td>
                                    <td className="text-center">{item.gp_name || "-"}</td>
                                    <td className="text-center">{item.meeting_date || "-"}</td>
                                    <td width={25}>
                                        <img
                                            src={Eye}
                                            onClick={() => handleViewClick(item.task_id)}
                                            className="cursor-pointer eye"
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

            </div>
        </div>
        </div>
    );
};

export default MultilingualDashboard2;
